<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";

export default {
    page: {
        title: "Outcomes",
    },
    data() {
        return {
            title: "Outcomes",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Outcomes",
                    active: true,
                },
            ],
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "cluster",
            sortDesc: false,
            fields: [
                {
                    key: "outcomeName",
                    sortable: true,
                },
                {
                    key: "uacs",
                    sortable: true,
                    label: "UACS",
                },
                // {
                //     key: "actions",
                //     thStyle: { width: "90px" },
                // },
            ],
            form: {
                id: 0,
                outcomeName: "",
                uacs: "",
                sectoralOutcomeId: "",
                agencyId: this.$store.state.data.agency.id,
            },
            indexSelected: -1,
            sectoralOutcome: {},
            tableBusy: false,
        };
    },
    validations: {
        form: {
            outcomeName: { required },
            uacs: { required },
            sectoralOutcomeId: { required },
        },
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    methods: {
        async getData(){
            this.tableBusy = true;
            await this.$store
                .dispatch("outcome/GetOutcome")
                .then((res) => {
                    this.tableData = res.data;
                    this.tableBusy = false;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                    this.tableBusy = false;
                });
            this.tableBusy = false;
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addFC() {
            this.onReset();
            this.modalTitle = "Create New Outcome";
            this.$bvModal.show("modal-standard");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("outcome/UpdateOutcome", this.form)
                        .then((res) => {
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                res.data
                            );
                            this.$bvModal.hide("modal-standard");
                            this.showToast("Successfully updated!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                } else {
                    this.$store
                        .dispatch("outcome/CreateOutcome", this.form)
                        .then((res) => {
                            this.tableData.push(res.data);
                            this.$bvModal.hide("modal-standard");
                            this.showToast("Successfully created!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                }
                this.submitted = false;
            }
        },
        onReset() {
            this.form = {
                id: 0,
                outcomeName: "",
                uacs: "",
                sectoralOutcomeId: "",
                agencyId: this.$store.state.data.agency.id,
            };
            this.sectoralOutcome = {};
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.sectoralOutcome = cloneDeep(props.item.sectoralOutcome)
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Outcome";
            this.$bvModal.show("modal-standard");
        },
        hideModal() {
            this.$bvModal.hide("modal-standard");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("outcome/DeleteOutcome", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast("Successfully deleted!","success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        getSr() {
            this.$refs.sr.getData();
            this.$bvModal.show("sectoral-outcome-modal");
        },
        getSectoralOutcome(data) {
            this.form.sectoralOutcomeId = data.id;
            this.sectoralOutcome = data;
        },
        viewPrexc(id) {
            this.$router.push(`/planning/prexc/${id}`);
        },
        dropData(data){
            console.log()
            this.$emit("dropData", data[0]);
            this.$bvModal.hide('outcome-modal')
        }
    },
};
</script>

<template>
    <b-modal
        id="outcome-modal"
        title="Outcome List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_length"
                    class="dataTables_length"
                >
                    <label
                        class="d-inline-flex align-items-center"
                    >
                        Show&nbsp;
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                    <label
                        class="d-inline-flex align-items-center"
                    >
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="
                                form-control form-control-sm
                                ms-2
                            "
                        ></b-form-input>
                    </label>
                </div>
            </div>
            <!-- End search -->
        </div>
        <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
                select-mode="single"
                selectable
                @row-selected="dropData"
                selected-variant="success"
            >
                <template #empty="scope">
                    <div class="text-center">
                        {{ scope.emptyText }}
                    </div>
                </template>
                <template #table-busy>
                    <div
                        class="
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div
                                    class="
                                        spinner-chase
                                        w-20px
                                        h-20px
                                    "
                                >
                                    <div
                                        class="chase-dot"
                                    ></div>
                                    <div
                                        class="chase-dot"
                                    ></div>
                                    <div
                                        class="chase-dot"
                                    ></div>
                                    <div
                                        class="chase-dot"
                                    ></div>
                                    <div
                                        class="chase-dot"
                                    ></div>
                                    <div
                                        class="chase-dot"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(outcomeName)="row">
                    <div class="text-dark">
                        <b>{{ row.value }}</b>
                    </div>
                    <div>
                        <small>Sectoral:&nbsp;&nbsp;{{row.item.sectoralOutcome.outcome}}</small>
                    </div>
                    <div>
                        <small>Societal:&nbsp;&nbsp;{{row.item.sectoralOutcome.societalOutcome.outcome}}</small>
                    </div>
                </template>
                <template #cell(actions)="row">
                    <div class="float-end">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu-end"
                            no-caret
                        >
                            <template #button-content>
                                <i
                                    class="fas fa-ellipsis-v"
                                ></i>
                            </template>
                            <b-dropdown-item
                                @click="viewPrexc(row.item.id)"
                                variant="secondary"
                                ><i
                                    class="
                                        mdi mdi-view-list
                                        font-size-18
                                        me-1
                                    "
                                ></i
                                >View Prexcs</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="updateItem(row)"
                                variant="secondary"
                                ><i
                                    class="
                                        mdi mdi-update
                                        font-size-18
                                        me-1
                                    "
                                ></i
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="deleteItem(row)"
                                variant="danger"
                                ><i
                                    class="
                                        mdi mdi-trash-can
                                        font-size-18
                                        me-1
                                    "
                                ></i
                                >Delete</b-dropdown-item
                            >
                        </b-dropdown>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                    "
                >
                    <ul
                        class="
                            pagination pagination-rounded
                            mb-0
                        "
                    >
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </b-modal>
</template>